<template>
  <v-dialog
    :value="true"
    max-width="550px"
    :persistent="saving"
    @input="!$event && close()"
  >
    <v-card>
      <v-card-title>Manage roles — {{ user.userName }}</v-card-title>
      <v-card-text>
        <v-alert
          v-if="error"
          dense
          text
          type="error"
        >
          {{ error }}
        </v-alert>
        <v-select
          v-model="selected"
          :items="options"
          label="User roles"
          multiple
          chips
          deletable-chips
          :loading="loading"
          :disabled="loading || saving || !loaded || !isSuperUser"
        />
        <p class="text-caption">
          Saving replaces this user's assigned roles.
        </p>
        <v-btn
          v-if="!loaded && !loading"
          text
          small
          @click="load"
        >
          Retry
        </v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="saving"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          :loading="saving"
          :disabled="!loaded || loading || saving || !isSuperUser"
          @click="save"
        >
          Save roles
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import Users from '@/services/UserDataService'
  import { roleNames } from '@/util/userRoles'
  export default {
    props: { user: { type: Object, required: true } },
    data: () => ({ options: [], selected: [], loading: false, loaded: false, saving: false, error: '', generation: 0 }),
    computed: { isSuperUser () { return this.$store.getters['authUser/isSuperUser'] } },
    mounted () { this.load() },
    beforeDestroy () { this.generation++ },
    methods: {
      close () { if (!this.saving) this.$emit('close') },
      message (error) { return error.response?.data?.message || error.message || 'Could not update user roles.' },
      async load () {
        if (!this.isSuperUser) return
        const generation = this.generation
        this.loading = true
        this.loaded = false
        this.error = ''
        try {
          const [available, assigned] = await Promise.all([Users.getAllRoles(), Users.getUserRoles(this.user.id || this.user.userId)])
          if (generation !== this.generation) return
          this.selected = roleNames(assigned.data)
          this.options = [...new Set([...roleNames(available.data), ...this.selected])]
          this.loaded = true
        } catch (error) { if (generation === this.generation) this.error = this.message(error) } finally { if (generation === this.generation) this.loading = false }
      },
      async save () {
        if (!this.isSuperUser || !this.loaded || this.loading || this.saving) return
        const generation = this.generation
        this.saving = true
        this.error = ''
        try {
          const response = await Users.updateUserRoles(this.user.id || this.user.userId, [...this.selected])
          if (generation !== this.generation) return
          if (response.data?.success === false || response.data?.isSuccess === false) throw new Error(response.data.message || 'Could not update user roles.')
          this.$toast.success('User roles updated successfully.', 'Success', { position: 'topRight' })
          this.$emit('saved')
        } catch (error) { if (generation === this.generation) this.error = this.message(error) } finally { if (generation === this.generation) this.saving = false }
      },
    },
  }
</script>
